import React, { useRef, useEffect } from 'react'
import { Fade } from 'react-awesome-reveal'
import { useTranslation } from 'gatsby-plugin-react-i18next'

const BlogSection = ({ onSectionChange, blogPosts, currentSection }) => {
  const blogSectionRef = useRef()

  const { t } = useTranslation()

  const handleScroll = (event) => {
    const scrollTop = blogSectionRef.current.getBoundingClientRect().bottom
    if (scrollTop <= 500 && currentSection === 'section6') {
      onSectionChange('section7')
    } else if (scrollTop > 500 && currentSection === 'section7') {
      onSectionChange('section6')
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })

  return (
    <section
      ref={blogSectionRef}
      id="section6"
      className="relative bg-gray-100 w-full"
    >
      <div className="w-5/6 md:w-3/4 lg:w-4/6 mx-auto py-16 text-center">
      <Fade direction="up">
        <h2 className="title font-bold text-4xl text-martinique text-left relative z-10">
        {t('blogSection.title')}
        </h2>
      </Fade>

        <div className="flex flex-col space-x-0 space-y-6 md:space-y-0 md:space-x-6 md:flex-row pt-12 md:pt-24 justify-between items-start content-center">
          {blogPosts.edges.map((value, index) => {
            return (
              <Fade key={index} delay={200 * index}>
              <article className="shadow-lg rounded-2xl bg-white duration-300 transform transition hover:-translate-y-3 text-left">
                <img alt={value.node.title} width="800" height="600" className="rounded-t-2xl" src={'https://miro.medium.com/max/400/' + value.node.virtuals.previewImage.imageId} />
                <a href={'https://alexandre-lion.medium.com/' + value.node.uniqueSlug } target="_target" className="hover:text-radical-red text-martinique duration-200 transition">
                  <h3 className="py-3 px-4 text-xl font-bold">{value.node.title}</h3>
                </a>
                <div className="pb-4 px-4 text-sm text-gray-500">{value.node.createdAt}</div>
              </article>
              </Fade>
            )
          })}
        </div>
        <a
        href="https://alexandre-lion.medium.com/"
        className="mx-auto"
        >
          <div className="inline-block bg-radical-red mt-20 px-5 py-4 font-bold text-white rounded-full transition duration-500 ease-in-out hover:bg-radical-red-400 transform hover:scale-110 relative z-10">
            {t('blogSection.readmore')} 👀
          </div>
        </a>
      </div>
    </section>
  )
}

export default BlogSection
